import { DataModel } from "common/models/utility-models/base-model";

export class RegisterStep2Model extends DataModel {
    fatherName:string = null;
    fatherProfession:string = null;
    motherName:string = null;
    motherProfession:string = null;
    familyAnnualIncome:number = 0;
}